module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/saloon-active.73814f10.svg";